import script from "./SwitcherComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitcherComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SwitcherComponent.vue?vue&type=style&index=0&id=7619af81&lang=css"

const __exports__ = script;

export default __exports__